import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const DEFAULT_CONFIG = {
  new_family_mediation_enabled: false,
  new_mediation_enabled: false, // alias legacy
  colega_link_initial_fee_clp: 13200,
  colega_link_agreement_rate: 0.08,
  family_mediation_total_cap_clp: 130602,
  mediation_fixed_initial_fee_clp: 13200,
  mediation_accord_pct: 8,
  max_mediator_session_fee_clp: 130602,
  min_colega_fee_clp: 30000,
  usar_uf: false,
  business_config: {
    // Mediaciones
    cargo_fijo_mediacion: 13200,
    porcentaje_comision_acuerdo: 0.08,
    usar_uf: false,
    tope_total_solicitante_clp: 130602,
    max_mediator_session_fee_clp: 130602,
    minutos_retraso_free_abogados: 10,
    // Membresías (CLP)
    plan_pionero_monthly_clp: 25000,
    plan_pionero_annual_clp: 234000,
    plan_premium_monthly_clp: 28000,
    plan_premium_annual_clp: 285000,
    // Comisiones (decimal 0..1)
    comision_delegacion_free: 0.10,
    comision_delegacion_pionero_activo: 0.0,
    comision_delegacion_pionero_post: 0.05,
    comision_delegacion_premium: 0.07,
    comision_delegacion_founder: 0.05,
    // Colega IA
    ai_included_queries: 30,
    ai_extra_pack_size: 20,
    ai_extra_pack_uf: 0.25,
    ai_extra_pack_clp_override: 0,
  },
};

const ConfigContext = createContext({ config: DEFAULT_CONFIG, loaded: false, refresh: async () => {} });

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState(DEFAULT_CONFIG);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/config/public", {
        params: { v: Date.now() },
        headers: { "Cache-Control": "no-cache" },
      });
      setConfig({ ...DEFAULT_CONFIG, ...data });
      setLoaded(true);
      return data;
    } catch { setLoaded(true); return null; }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <ConfigContext.Provider value={{ config, loaded, refresh }}>{children}</ConfigContext.Provider>;
}

export function useConfig() {
  return useContext(ConfigContext);
}
